function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512.063 512.063",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6600"
    },
    d: "M18.064,193.007l12.864,49.36c2.8,10.832,5.408,20.88,7.216,30.912h0.608 c2.208-9.84,5.408-20.272,8.608-30.704l15.872-49.552h14.816l15.072,48.56c3.6,11.632,6.416,21.872,8.608,31.712h0.608 c1.6-9.84,4.24-20.08,7.456-31.504l13.824-48.752h17.472l-31.296,97.12h-16.08l-14.864-46.352 c-3.408-10.816-6.208-20.448-8.608-31.888h-0.416c-2.4,11.632-5.408,21.68-8.816,32.096l-15.664,46.16H29.328L0,193.007H18.064z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6600"
    },
    d: "M168.064,193.007l12.864,49.36c2.8,10.832,5.408,20.88,7.216,30.912h0.608 c2.208-9.84,5.408-20.272,8.608-30.704l15.872-49.552h14.816l15.072,48.56c3.6,11.632,6.416,21.872,8.608,31.712h0.608 c1.6-9.84,4.24-20.08,7.456-31.504l13.824-48.752h17.472l-31.296,97.12h-16.064l-14.864-46.352 c-3.408-10.816-6.208-20.448-8.608-31.888h-0.4c-2.4,11.632-5.408,21.68-8.816,32.096l-15.664,46.16h-16.032l-29.328-97.12h18.048 V193.007z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6600"
    },
    d: "M318.112,193.007l12.816,49.36c2.8,10.832,5.408,20.88,7.216,30.912h0.608 c2.208-9.84,5.456-20.272,8.656-30.704l15.824-49.552h14.864l15.072,48.56c3.6,11.632,6.416,21.872,8.608,31.712h0.608 c1.6-9.84,4.208-20.08,7.408-31.504l13.856-48.752h17.424l-31.296,97.12h-16.032l-14.864-46.352 c-3.408-10.816-6.208-20.448-8.608-31.888h-0.4c-2.4,11.632-5.456,21.68-8.848,32.096l-15.632,46.16h-16.064l-29.28-97.12h18.064 V193.007z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#22ACDD"
    },
    d: "M366.448,369.007c-41.632,0-81.088-20.128-105.568-53.84l11.616-8.448 c21.792,30.032,56.912,47.952,93.952,47.952c63.968,0,116.032-52.064,116.032-116.032s-52.064-116.032-116.032-116.032 c-42.928,0-82.176,23.552-102.432,61.472l-12.656-6.768c22.752-42.592,66.848-69.056,115.088-69.056 c71.888,0,130.368,58.48,130.368,130.368S438.336,369.007,366.448,369.007z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433.141,
    y: 360.939,
    transform: "matrix(-0.7063 -0.7079 0.7079 -0.7063 552.3334 965.3643)",
    style: {
      fill: "#22ACDD"
    },
    width: 86.559,
    height: 14.336
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.67948dc09338cd253d10b56e1dbb8ce6.svg";
export { ForwardRef as ReactComponent };